import React from "react";
import { Flex } from "rebass";
import { get } from "lodash";
import {
  // NumberInput,
  ReferenceInput,
  // ArrayInput,
  AutocompleteInput,
  SelectInput,
} from "react-admin";
import { useStyles } from "./styles";
// import TableFormIterator from "./TableFormIterator";
import { withStyles, createStyles } from "@material-ui/core/styles";
import CardTable, { dataCriteriaType } from "./CardTable";
import { ThemeProvider } from "@material-ui/styles";
import { themeTableInput } from "../../../themes";
import ProductShortCodeInput from "./ProductShortCodeInput";
import { SPMOQ } from "./TableStyles";
const mystyles = (theme) =>
  createStyles({
    root: {
      width: "100%",
    },
  });

const SpecialPrice = (props) => {
  const {
    formData,
    checkEmptyValue,
    dataProducts,
    updateField,
    ...rest
  } = props;
  const classes = useStyles();
  const type_buy = get(formData, "criteria.price.buy.type", "");

  return (
    <Flex
      width={[1]}
      flexDirection={"column"}
      sx={{
        "&>div": {
          pb: [3],
        },
      }}
    >
      <CardTable {...props} title={"resources.promotions.fields.buy"}>
        <Flex flexDirection='row' width={[1]} justifyContent='flex-start'>
          <SelectInput
            source='criteria.price.buy.type'
            choices={dataCriteriaType}
            label={"resources.promotions.labels.criteria_type"}
            style={{ paddingRight: 16 }}
          />
          {(type_buy === "ProductGroup" || type_buy === "SubProductGroup") && (
            <ReferenceInput
              label={"resources.promotions.labels.criteria"}
              source='criteria.price.buy.id'
              reference='codes'
              className={classes.product}
              filter={{ type: type_buy, active: true }}
              sort={{ field: "label", order: "ASC" }}
              perPage={1000}
            >
              <AutocompleteInput optionText='label' />
            </ReferenceInput>
          )}
          {type_buy === "ProductCode" && (
            // <ReferenceInput
            //   label={"resources.promotions.labels.criteria"}
            //   source='criteria.price.buy.id'
            //   reference='products'
            //   filter={{ type: type_buy }}
            //   perPage={1000}
            //   className={classes.product}
            // >
            //   <AutocompleteInput optionText='packaging' optionValue={"id"} />
            // </ReferenceInput>
            <ProductShortCodeInput
              record={formData}
              source='criteria.price.buy.id'
              optionValue={"code"}
              updateField={updateField}
              label={"resources.promotions.labels.criteria"}
              list={dataProducts || []}
            />
          )}
          {type_buy === "ProductShortCode" && (
            // <ReferenceInput
            //   label={"resources.promotions.labels.criteria"}
            //   source='criteria.price.buy.id'
            //   reference='products'
            //   filter={{ type: type_buy }}
            //   perPage={1000}
            //   className={classes.product}
            // >
            //   <AutocompleteInput
            //     optionText='packaging'
            //     optionValue={"short_code"}
            //   />
            // </ReferenceInput>
            <ProductShortCodeInput
              record={formData}
              source='criteria.price.buy.id'
              optionValue={"short_code"}
              updateField={updateField}
              label={"resources.promotions.labels.criteria"}
              list={dataProducts || []}
            />
          )}
        </Flex>
      </CardTable>

      <ThemeProvider theme={themeTableInput}>
        <Flex width={[1]} flexDirection={"column"}>
          {/* <ArrayInput source='criteria.price.moqs' {...rest} label={""}>
            <TableFormIterator
              {...rest}
              disableAdd={true}
              disableRemove={true}
              widthTable={"400px"}
            >
              <NumberInput
                source='moq'
                style={{ width: 100, margin: 0 }}
                label={"resources.promotions.fields.moq"}
                onBlur={(e) => checkEmptyValue(e.target.name, e.target.value)}
              />
              <NumberInput
                source='price'
                style={{ width: 100, margin: 0 }}
                label={"resources.promotions.fields.price"}
                onBlur={(e) => checkEmptyValue(e.target.name, e.target.value)}
              />
            </TableFormIterator>
          </ArrayInput> */}
          <SPMOQ {...rest} checkEmptyValue={checkEmptyValue} />
        </Flex>
      </ThemeProvider>
    </Flex>
  );
};

export default withStyles(mystyles)(SpecialPrice);
